/**
 * Shared error helpers for service layer.
 *
 * Enriches thrown errors with HTTP status codes so that QueryClient's
 * shouldRetry can distinguish transient failures from permanent ones
 * (429 rate-limit, 401/403 auth).
 */

export interface ApiError extends Error {
  status?: number;
  rateLimitHit?: boolean;
}

/**
 * Build an ApiError from a Supabase Functions error.
 *
 * Supabase wraps the HTTP response in `error.context` – we pull the
 * numeric status from there and flag 429s with `rateLimitHit`.
 */
export function createServiceError(
  message: string,
  supabaseError?: { context?: { status?: number }; message?: string } | null,
): ApiError {
  const err = new Error(message) as ApiError;

  const status = (supabaseError as any)?.context?.status as number | undefined;
  if (status) {
    err.status = status;
  }

  if (status === 429) {
    err.rateLimitHit = true;
  }

  return err;
}
